class AcaoAnotarController {
  makeDefaultErrorsFields() {
    return {
      idTipoHistorico: {
        error: false,
        errorMessage: '',
      },
      texto: {
        error: false,
        errorMessage: '',
      },
      tipoProcessoContatoSelecionado: {
        error: false,
        errorMessage: '',
      },
      ddd: {
        error: false,
        errorMessage: '',
      },
      telefone: {
        error: false,
        errorMessage: '',
      },
      nomeContatoRecado: {
        error: false,
        errorMessage: '',
      },
    };
  }
}

export const acaoAnotarController = new AcaoAnotarController();
